import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";

const PortfoliosSection = ({ portfoliosData }) => {
    const controls = useAnimation();
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

    useEffect(() => {
        if (inView) {
            controls.start("visible");
        } else {
            controls.start("hidden"); // Hide again when out of view
        }
    }, [inView, controls]);

    return (
        <motion.div
            initial="hidden"
            animate={controls}
            variants={{
                hidden: { opacity: 0, y: 50 },
                visible: { opacity: 1, y: 0, transition: { duration: 1, ease: "easeOut" } },
            }}
            className="bg-white text-black py-10  text-left "
        >
            {/* Heading */}
            <motion.h2
                        ref={ref}
                className="text-2xl md:text-4xl font-bold mb-6"
                variants={{
                    hidden: { opacity: 0, y: 50 },
                    visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay: 0.2 } },
                }}
                initial="hidden"
                animate={controls}
            >
                <span className="text-green-800">Our</span> <span className="text-green-800">Portfolios. </span>
                <span className="text-gray-600 font-semibold text-md">Innovative Solutions Driving Excellence Across Industries.</span>
            </motion.h2>


            {/* Image Containers */}
            <div className="flex flex-col md:flex-row gap-6 justify-center items-center w-full space-y-6 md:space-y-0 mt-12">
                {portfoliosData.map((item, index) => (
                    <motion.div
                        key={index}
                        className="w-full md:w-1/3 relative text-white group overflow-hidden rounded-2xl"
                        variants={{
                            hidden: { opacity: 0, y: 50 },
                            visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay: 0.2 + index * 0.2 } },
                        }}
                        whileHover="hover"
                        initial="hidden"
                        animate={controls}
                    >
                        {/* Image */}
                        <img
                            src={item.img}
                            alt={item.title}
                            className="w-full rounded-2xl h-[500px] object-cover transition-transform duration-300 group-hover:scale-105"
                        />

                        {/* Glassy Black Overlay */}
                        <div className="absolute inset-0 bg-black/40 rounded-2xl"></div>

                        {/* Title Animation */}
                        {/* Title (Moves Up on Hover, Moves Down on Exit) */}
                        <motion.div variants={{ initial: { y: 0 }, hover: { y: -30 }, }} transition={{ duration: 0, ease: "easeOut" }}
                            className="absolute bottom-6 left-6 z-10 transition-all duration-300">
                            <h3 className="text-xl font-bold pb-4">{item.title}</h3>
                        </motion.div>

                        {/* Learn More Button (Appears & Moves Up on Hover, Moves Down on Exit) */}
                        <motion.div variants={{ initial: { y: 30, opacity: 0 }, hover: { y: 0, opacity: 1 }, }} transition={{
                            duration:
                                0, ease: "easeOut"
                        }}
                            className="absolute bottom-6 left-6 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                                <a href={`/products/${item.id}`} className="hover:text-green-400">
                            <button className="bg-green-500 text-white px-4 py-2 rounded-lg shadow-md">Learn More →</button>
                            </a>
                        </motion.div>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
};

export default PortfoliosSection;
